<template>
  <a-modal
    title="设置教室"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 当前教室 -->
      <a-form-item
        label="当前教室"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <div class="placeShow">
          <span>{{ classData.placeName }}</span>
          <a class="remove" v-show="classData.placeName" @click="removePlace">移除</a>
        </div>
      </a-form-item>
      <!-- 教室 -->
      <a-form-item
        label="请选择更换的教室"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select allowClear placeholder="请选择" v-decorator="['classroomId']">
          <a-select-option
            v-for="(item, index) in classroomList"
            :key="index"
            :value="item.id"
            :disabled="item.id == classData.placeId"
            >{{ item.placeName }}</a-select-option
          >
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import classroom from "../../../api/classroom";

import classSet from "../../../api/classSet";

export default {
  name: "classClassroomModal",
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classData: {},
      classroomList: [], //教室列表
    };
  },
  methods: {
    //获取教室列表
    getClassroomList() {
      classroom
        .listPlace(this.classData.id)
        .then(res => {
          this.classroomList = res.data;
        })
        .catch(err => {
          this.classroomList = [];
        });
    },

    //初始化，显示
    init(params) {
      console.log("params----------", params);
      this.visible = true;
      this.classData = { ...params };
      if (params) {
        this.getClassroomList();
        let formData = {};
        // formData.classroomId = params.placeId;
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.form.resetFields("classroomId");
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          this.resetPlace(value);
        }
      });
    },

    //安排教室
    resetPlace(value) {
      let req = {
        id: this.classData.id,
        placeId: value.classroomId == undefined ? (this.classData.placeId ? this.classData.placeId : "") : value.classroomId,
      };
      classroom.resetPlace(req).then(res => {
        console.log("安排教室------", res.data);
        this.$message.success("设置教室成功");
        //前端列表回显教室列表
        this.$parent.pageRefresh();
        this.$set(this.classData, "placeId", res.data.placeId);
        this.$set(this.classData, "placeName", res.data.placeName);

        this.handleCancel();
      });
    },
    //移除当前教室
    removePlace() {
      // this.form.resetFields("classroomId");
      this.classData.placeId = "";
      this.classData.placeName = "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";

.placeShow {
  display: flex;
  justify-content: space-between;
}

.remove {
  color: #178fff;
  margin-left: 20px;
}
</style>
